import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { resetPasswordWithToken } from "../api/mobileRegistrationApi";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get("token") || "";
  const [token, setToken] = useState(tokenFromUrl);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [err, setErr] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setMessage(null);
    if (password.length < 8) {
      setErr("Password must be at least 8 characters.");
      return;
    }
    if (password !== password2) {
      setErr("Passwords do not match.");
      return;
    }
    if (!API_BASE_URL) {
      setErr("API URL is not configured.");
      return;
    }
    setLoading(true);
    try {
      const data = await resetPasswordWithToken(API_BASE_URL, token.trim(), password);
      setMessage(data.message || "Password updated.");
    } catch (e2) {
      setErr(e2.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: "4rem auto", padding: "0 1rem" }}>
      <h1 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>Set a new password</h1>
      <p style={{ color: "#6b7280", marginBottom: "1.5rem", fontSize: "0.95rem" }}>
        Paste the token from your email if it is not filled automatically, then choose a new password.
      </p>
      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div>
          <label style={{ display: "block", fontWeight: 600, marginBottom: "0.35rem" }}>Reset token</label>
          <input
            value={token}
            onChange={(e) => setToken(e.target.value)}
            required
            style={{ width: "100%", padding: "0.65rem 0.75rem", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: "0.85rem" }}
          />
        </div>
        <div>
          <label style={{ display: "block", fontWeight: 600, marginBottom: "0.35rem" }}>New password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            style={{ width: "100%", padding: "0.65rem 0.75rem", borderRadius: 8, border: "1px solid #e5e7eb" }}
          />
        </div>
        <div>
          <label style={{ display: "block", fontWeight: 600, marginBottom: "0.35rem" }}>Confirm password</label>
          <input
            type="password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
            minLength={8}
            style={{ width: "100%", padding: "0.65rem 0.75rem", borderRadius: 8, border: "1px solid #e5e7eb" }}
          />
        </div>
        {err && <div style={{ color: "#b91c1c", fontSize: "0.9rem" }}>{err}</div>}
        {message && <div style={{ color: "#15803d", fontSize: "0.9rem" }}>{message}</div>}
        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "0.75rem 1rem",
            background: "#0d9488",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontWeight: 600,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Saving…" : "Update password"}
        </button>
      </form>
      <p style={{ marginTop: "1.5rem" }}>
        <Link to="/">Back to home</Link>
      </p>
    </div>
  );
}
